import Dashboard from "../../assets/images/sidebar/dashboard.svg";

const dashboardModule = {
  name: "Dashboard",
  key: "dashboard",
  imgSrc: Dashboard,
  fixed: true,
  alwaysShow: true,
  defaultEnabled: true,
  submodules: [
    {
      name: "Setup",
      key: "setup",
      defaultExpanded: false,
      features: [
        {
          key: "setup",
          name: "Setup",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_the_setup_assistant_component",
              name: "View the Setup & Assistant Component",
              defaultEnabled: true,
              description: "Displays setup dashboard components based on role permissions"
            },
            {
              key: "manage_team",
              name: "Manage Team",
              defaultEnabled: false,
              description: "Redirect to team management or skip step"
            },
            {
              key: "manage_categories_and_services",
              name: "Manage Categories and Services",
              defaultEnabled: false,
              description: "Redirect to category/service management or skip step"
            },
            {
              key: "manage_client",
              name: "Manage Client",
              defaultEnabled: false,
              description: "Redirect to client management or skip step"
            },
          ]
        }
      ]
    },
    {
      name: "Main Dashboard",
      key: "main_dashboard",
      defaultExpanded: false,
      features: [
        {
          key: "main_dashboard",
          name: "Main Dashboard",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_compliance_calendar",
              name: "View Compliance Calendar",
              defaultEnabled: true,
              description: "Shows compliance calendar widget with link to full view"
            },
            {
              key: "view_chart_2",
              name: "View Chart 2",
              defaultEnabled: false,
              description: "Displays Chart 2 widget with redirection to details"
            }
          ]
        }
      ]
    }
  ]
};

export default dashboardModule;
